import UserPage from "src/pages/User";
import { createGetServerSideProps } from "src/utilities/ssr/createGetServerSideProps";
import {
  getUserServerSideProps,
  getUserPageLikesFeed,
} from "src/utilities/ssr/getUserServerSideProps";
import { withPropsDeserialization } from "src/utilities/ssr/withPropsDeserialization";

export const getServerSideProps = createGetServerSideProps(
  getUserServerSideProps(getUserPageLikesFeed)
);

export default withPropsDeserialization(UserPage);
